/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./FramebufferObject.js";
import t from "./Texture.js";

function n(e, n) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "nearest";
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var r;
  var o = !(i && "u8" === n.pixelType),
      s = o ? 5126 : 5121,
      u = null == n.pixels || 0 === n.pixels.length ? null : o ? n.getAsRGBAFloat() : n.getAsRGBA(),
      l = null == (r = e.capabilities.textureFloat) ? void 0 : r.textureFloatLinear,
      f = {
    width: n.width,
    height: n.height,
    target: 3553,
    pixelFormat: 6408,
    internalFormat: "webgl2" === e.webglVersion && o ? 34836 : 6408,
    samplingMode: !l || "bilinear" !== a && "cubic" !== a ? 9728 : 9729,
    dataType: s,
    wrapMode: 33071,
    flipped: !1
  };
  return new t(e, f, u);
}

function a(n, a, i, r) {
  var o = new t(n, {
    width: a,
    height: i,
    target: 3553,
    pixelFormat: 6408,
    internalFormat: 6408,
    samplingMode: 9728,
    dataType: r ? 5121 : 5126,
    wrapMode: 33071,
    flipped: !1
  });
  return new e(n, {
    colorTarget: 0,
    depthStencilTarget: 3,
    width: a,
    height: i
  }, o);
}

function i(e, n) {
  var a = 4 * n.size[0],
      i = n.size[1],
      r = {
    width: a,
    height: i,
    target: 3553,
    pixelFormat: 6408,
    internalFormat: "webgl2" === e.webglVersion ? 34836 : 6408,
    dataType: 5126,
    samplingMode: 9728,
    wrapMode: 33071,
    flipped: !1
  },
      o = new Float32Array(a * i * 4);
  var s = 0;

  for (var _t = 0; _t < n.coefficients.length; _t++) {
    o[s++] = n.coefficients[_t], _t % 3 == 2 && (o[s++] = 1);
  }

  return new t(e, r, o);
}

function r(e, n) {
  var a = {
    width: n.length / 4,
    height: 1,
    target: 3553,
    pixelFormat: 6408,
    internalFormat: 6408,
    dataType: 5121,
    samplingMode: 9728,
    wrapMode: 33071,
    flipped: !1
  };
  return new t(e, a, n);
}

function o(e, t, n) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  return {
    u_flipY: i,
    u_isFloatTexture: r,
    u_applyTransform: !!e,
    u_opacity: a,
    u_transformSpacing: e ? e.spacing : null,
    u_transformGridSize: e ? e.size : null,
    u_targetImageSize: t,
    u_srcImageSize: n
  };
}

function s(e, t) {
  return {
    u_colormapOffset: t || 0,
    u_colormapMaxIndex: e ? e.length / 4 - 1 : null
  };
}

function u(e, t) {
  return {
    u_scale: e,
    u_offset: t
  };
}

function l(e) {
  return {
    u_bandCount: e.bandCount,
    u_minOutput: e.outMin,
    u_maxOutput: e.outMax,
    u_minCutOff: e.minCutOff,
    u_maxCutOff: e.maxCutOff,
    u_factor: e.factor,
    u_useGamma: e.useGamma,
    u_gamma: e.gamma,
    u_gammaCorrection: e.gammaCorrection
  };
}

function f(e) {
  return {
    u_hillshadeType: e.hillshadeType,
    u_sinZcosAs: e.sinZcosAs,
    u_sinZsinAs: e.sinZsinAs,
    u_cosZs: e.cosZs,
    u_weights: e.weights,
    u_factor: e.factor,
    u_minValue: e.minValue,
    u_maxValue: e.maxValue
  };
}

function m(e, t) {
  var n = e.gl,
      a = t.glName,
      i = n.getProgramParameter(a, n.ACTIVE_UNIFORMS),
      r = new Map();
  var o;

  for (var _s = 0; _s < i; _s++) {
    o = n.getActiveUniform(a, _s), o && r.set(o.name, {
      location: n.getUniformLocation(a, o.name),
      info: o
    });
  }

  return r;
}

function c(e, t, n) {
  Object.keys(n).forEach(function (a) {
    var i = t.get(a) || t.get(a + "[0]");
    i && p(e, a, n[a], i);
  });
}

function g(e, t, n, a) {
  n.length === a.length && (a.some(function (e) {
    return null == e;
  }) || n.some(function (e) {
    return null == e;
  }) || n.forEach(function (n, i) {
    t.setUniform1i(n, i), e.bindTexture(a[i], i);
  }));
}

function p(e, t, n, a) {
  if (null === a || null == n) return !1;
  var i = a.info;

  switch (i.type) {
    case 5126:
      i.size > 1 ? e.setUniform1fv(t, n) : e.setUniform1f(t, n);
      break;

    case 35664:
      e.setUniform2fv(t, n);
      break;

    case 35665:
      e.setUniform3fv(t, n);
      break;

    case 35666:
      e.setUniform4fv(t, n);
      break;

    case 35675:
      e.setUniformMatrix3fv(t, n);
      break;

    case 35676:
      e.setUniformMatrix4fv(t, n);
      break;

    case 5124:
      i.size > 1 ? e.setUniform1iv(t, n) : e.setUniform1i(t, n);
      break;

    case 35670:
      e.setUniform1i(t, n ? 1 : 0);
      break;

    case 35667:
    case 35671:
      e.setUniform2iv(t, n);
      break;

    case 35668:
    case 35672:
      e.setUniform3iv(t, n);
      break;

    case 35669:
    case 35673:
      e.setUniform4iv(t, n);
      break;

    default:
      return !1;
  }

  return !0;
}

export { r as createColormapTexture, a as createFrameBuffer, n as createRasterTexture, i as createTransformTexture, u as getBasicGridUniforms, s as getColormapUniforms, o as getCommonUniforms, f as getShadedReliefUniforms, l as getStretchUniforms, m as getUniformLocationInfos, g as setTextures, c as setUniforms };